var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 5,
    fill: "#FF6201"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0207 17.6667C29.2967 17.6667 27.3527 22.9334 27.1034 29.6667H34.938C34.6887 22.9347 32.7447 17.6667 31.0207 17.6667ZM26.8127 18.3334C21.8967 19.9721 18.1954 24.4681 17.7287 29.6667H24.4367C24.5847 25.0814 25.4127 21.0147 26.8127 18.3334ZM35.2287 18.3334C36.6287 21.0147 37.4567 25.0814 37.6047 29.6667H44.2713C43.7887 24.4067 40.1927 20.0014 35.2287 18.3334ZM17.77 32.3334C18.25 37.6761 21.9594 42.0534 26.854 43.6667C25.4554 40.9854 24.5847 36.9187 24.4367 32.3334H17.77ZM27.1034 32.3334C27.3527 39.0654 29.2967 44.3334 31.0207 44.3334C32.7447 44.3334 34.6887 39.0667 34.938 32.3334H27.1034ZM37.6047 32.3334C37.4567 36.9187 36.586 40.9854 35.1874 43.6667C40.2154 41.9561 43.7807 37.5067 44.2713 32.3334H37.6047Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc1);
export default __webpack_public_path__ + "static/media/ic-1.fbe7546e27921075d581d8e74d5241ad.svg";
export { ForwardRef as ReactComponent };